import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/admiral.png'
import _imports_1 from '@/assets/images/smolniy.png'
import _imports_2 from '@/assets/images/cremlin.png'
import _imports_3 from '@/assets/images/pushka.png'
import _imports_4 from '@/assets/images/murmansk.png'
import _imports_5 from '@/assets/images/ledocol.png'


const _withScopeId = n => (_pushScopeId("data-v-56b31587"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-full object-cover rounded-[50px]"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-full object-cover rounded-[50px]"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "w-full object-cover rounded-[50px]"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "w-full object-cover rounded-[50px]"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "w-full object-cover rounded-[50px]"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "w-full object-cover rounded-[50px]"
}, null, -1))

import { Swiper, SwiperSlide } from 'swiper/vue';
import { Scrollbar } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/scrollbar';

export default /*#__PURE__*/_defineComponent({
  __name: 'SixthSection',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Swiper), {
    slidesPerView: 'auto',
    spaceBetween: 30,
    modules: [_unref(Scrollbar)],
    centeredSlides: "",
    scrollbar: { draggable: true },
    "grab-cursor": ""
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(SwiperSlide), null, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_unref(SwiperSlide), null, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_unref(SwiperSlide), null, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_unref(SwiperSlide), null, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_unref(SwiperSlide), null, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(_unref(SwiperSlide), null, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modules"]))
}
}

})